import { useIntl } from 'react-intl';

import { ApiWorkflowDialogMessages } from '@verantos-dev/shared-components';

export const useExportCohortModalStrings = () => {
  const intl = useIntl();
  const contentMessages = {
    path: intl.formatMessage({ id: 'cohortsList.exportCohortModal.path' }),
    project: intl.formatMessage({ id: 'cohortsList.exportCohortModal.project' }),
    location: intl.formatMessage({ id: 'cohortsList.exportCohortModal.location' }),
    cohort: intl.formatMessage({ id: 'cohortsList.exportCohortModal.cohort' }),
    title: intl.formatMessage({ id: 'cohortsList.exportCohortModal.title' }),
    description: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.description',
    }),
    projectName: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.projectName',
    }),
    cohortName: intl.formatMessage({
      id: 'cohortsList.createCohortModal.cohortName.label',
    }),
    exportLocation: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.exportLocation',
    }),
    exportLocationPlaceholder: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.exportLocationPlaceholder',
    }),
    schemaName: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.schemaName',
    }),
    schemaNamePlaceholder: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.schemaNamePlaceholder',
    }),
    schemaNameHelptext: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.schemaNameHelptext',
    }),
    fileName: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.fileName',
    }),
    fileNamePlacholder: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.fileNamePlaceholder',
    }),
    fileNameHelptext: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.fileNameHelptext',
    }),
    fileType: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.fileType',
    }),
    fileTypeCsv: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.fileType.csv',
    }),
    fileTypeParquet: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.fileType.parquet',
    }),
  };

  const dialogMessages: ApiWorkflowDialogMessages = {
    loadingCancelButtonText: intl.formatMessage({
      id: 'cohortsList.createCohortModal.cancelButton',
    }),
    loadingSaveButtonText: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.exportButton',
    }),
    entryCancelButtonText: intl.formatMessage({
      id: 'cohortsList.createCohortModal.cancelButton',
    }),
    entrySaveButtonText: intl.formatMessage({ id: 'cohortsList.exportCohortModal.exportButton' }),
    submittingCancelButtonText: intl.formatMessage({
      id: 'cohortsList.createCohortModal.cancelButton',
    }),
    submittingSaveButtonText: intl.formatMessage({
      id: 'cohortsList.exportCohortModal.submitting',
    }),
    successCloseButtonText: intl.formatMessage({
      id: 'cohortsList.createCohortModal.closeButton',
    }),
    submittingErrorTitle: intl.formatMessage({
      id: 'cohortsList.createCohortModal.submittingError',
    }),
    successTitle: intl.formatMessage({ id: 'cohortsList.createCohortModal.success.title' }),
    successText: intl.formatMessage({ id: 'cohortsList.exportCohortModal.success.text' }),
  };

  return {
    dialogMessages,
    contentMessages,
  };
};
